import { useAppActions } from 'reducers/slices/myBundleSlice';
import { useSelector } from 'react-redux';

export default () => {
  const { loadMyBundle, updateMyBundle } = useAppActions();
  const { loading, myBundle } = useSelector(state => state.myBundleSlice);

  return {
    loadMyBundle,
    myBundle,
    loading,
    updateMyBundle,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/useMyBundle.js